import { createSlice } from '@reduxjs/toolkit';
import { isAuthenticated } from '../../../routing/isAuthenticated';
import { login, logout, signUp } from '../../reducers/account/accountThunks';
import { handleRequestThunk } from '../handleRequestThunk';
const SLICE_NAME = 'auth';

export const authSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        data: {
            isAuthenticated: isAuthenticated(),
        },
        isLoading: false,
        error: null,
    },
    reducers: {
        setIsAuthenticated(state, action) {
            state.error = null;
            state.data.isAuthenticated = action.payload;
            state.isLoading = false;
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: login });
        handleRequestThunk({ builder, request: signUp });
        handleRequestThunk({ builder, request: logout });
    },
});

export const selectIsAuthenticated = (state) => {
    return state.auth.data.isAuthenticated;
};
export const selectAuthError = (state) => state.auth.error;
export const selectAuthLoading = (state) => state.auth.isLoading;

export const { setIsAuthenticated } = authSlice.actions;

export const auth = authSlice.reducer;
